<div class="container" *ngIf="!isNotStartTaskField">
    <kendo-numerictextbox [value]="value" [format]="format" [spinners]="false" [readonly]="true">
    </kendo-numerictextbox>
</div>
<div *ngIf="isNotStartTaskField">
    <span class='not-start-field'>{{'general.not_start' | stringLiterals}}</span>
</div>